import React from "react";
import CFTimage from "../../../assets/CFT.png";
import {
  HeartFill,
  ShieldFill,
  PeopleFill,
  EmojiSmileFill,
  ArrowRepeat,
  LightbulbFill,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "compassion") return <HeartFill className="therapy-icon" />;
  if (name === "safe") return <ShieldFill className="therapy-icon" />;
  if (name === "relationships") return <PeopleFill className="therapy-icon" />;
  if (name === "soothe") return <EmojiSmileFill className="therapy-icon" />;
  if (name === "practice") return <ArrowRepeat className="therapy-icon" />;
  if (name === "idea") return <LightbulbFill className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function CFTModal({ setShow }) {
  return (
    <>
      <div className="therapy-modal-backdrop" onClick={() => setShow(false)} />

      <div
        className="modal fade show d-block therapy-modal-wrap"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={CFTimage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="CFT"
                />

                <h5 className="therapy-modal-title">What is CFT</h5>

                <div className="therapy-modal-subtitle">
                  Compassion Focused Therapy explained
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="compassion" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Compassion Focused Therapy
                    </div>
                    <div className="therapy-modal-item-text">
                      CFT is an evidence based therapy that helps you build a
                      kinder and more supportive inner voice. It is especially
                      helpful when shame, harsh self criticism, or feeling not
                      good enough keeps you stuck.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="safe" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Safety first and pacing
                    </div>
                    <div className="therapy-modal-item-text">
                      Sessions often start by building stability and emotional
                      safety. You go at a pace that feels manageable, with tools
                      to help you stay grounded while exploring difficult
                      feelings.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="soothe" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Regulating the nervous system
                    </div>
                    <div className="therapy-modal-item-text">
                      CFT includes practical ways to activate the soothing
                      system, such as breathing, imagery, and body based
                      regulation, so emotions feel less overwhelming.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      Compassion is not weakness,
                    </span>{" "}
                    it is a skill you can train to support confidence, courage,
                    and emotional balance.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      CFT can help clients to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>Reduce shame and soften harsh self criticism</div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>Build self reassurance during stress and setbacks</div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Feel safer in relationships and more connected to
                          others
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>Improve mood, anxiety, and resilience over time</div>
                      </div>
                    </div>
                  </div>

                  <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      CFT is often used for anxiety, depression, trauma, and long
                      standing patterns linked to shame. Therapists may use
                      compassion imagery, chair work, and exercises that help
                      you practise a steadier and kinder way of relating to
                      yourself.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="relationships" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Strengthening how you relate to yourself and others
                    </div>
                    <div className="therapy-modal-item-text">
                      As self criticism reduces, many people find it easier to
                      set boundaries, ask for support, and respond to challenges
                      with more clarity and confidence.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="practice" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Practise between sessions
                    </div>
                    <div className="therapy-modal-item-text">
                      Progress comes from repetition. You will usually be given
                      small exercises to practise, helping compassion become a
                      natural response rather than something you have to force.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
